import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "position-absolute start-50 translate-middle-x" }
const _hoisted_2 = {
  type: "button",
  class: "btn bg-secondary border-0 bg-opacity-05 d-flex align-items-center py-3 px-4",
  "data-bs-target": "#MagicRemoteJoystick",
  "aria-controls": "MagicRemoteJoystick",
  "data-bs-toggle": "offcanvas"
}
const _hoisted_3 = { class: "ms-2" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end fs-4" }
const _hoisted_5 = { class: "m-0 p-0 ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brand_logo = _resolveComponent("brand-logo")!
  const _component_icon_component = _resolveComponent("icon-component")!
  const _component_btn_audio = _resolveComponent("btn-audio")!
  const _component_btn_home = _resolveComponent("btn-home")!
  const _component_language_switcher = _resolveComponent("language-switcher")!
  const _component_app_header = _resolveComponent("app-header")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createBlock(_component_app_header, {
    variant: "empty",
    "container-class": "container-fluid  px-md-5 d-flex align-items-center justify-content-between"
  }, {
    brand: _withCtx(() => [
      _createVNode(_component_brand_logo, {
        to: "/home",
        "img-class": "el-scale",
        "img-style": "max-height: 52px; max-width: 129px",
        "fallback-src": _ctx.fallbackLogo
      }, null, 8, ["fallback-src"])
    ]),
    center: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createVNode(_component_icon_component, {
            lib: 'material',
            icon: 'settings_remote'
          }),
          _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
            [_directive_t, 'magic_remote.buttons.global']
          ])
        ])
      ])
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_btn_audio, { class: "me-3" }),
        (_ctx.$route.name !== 'home')
          ? (_openBlock(), _createBlock(_component_btn_home, {
              key: 0,
              onGohome: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ name: 'home' })))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_language_switcher, { class: "d-inline-block ms-3" }),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.time), 1)
      ])
    ]),
    _: 1
  }))
}